import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { useLenisScroll } from "@/hooks/useLenis";

import Loader from "@/components/site/Loader";
import SEO from "@/components/site/SEO";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import Marquee from "@/components/site/Marquee";
import Collection from "@/components/site/Collection";
import TwoPaths from "@/components/site/TwoPaths";
import PrivateLabel from "@/components/site/PrivateLabel";
import WhyUs from "@/components/site/WhyUs";
import Process from "@/components/site/Process";
import Gallery from "@/components/site/Gallery";
import Counters from "@/components/site/Counters";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import PrivateLabelForm from "@/components/site/PrivateLabelForm";
import Gifting from "@/components/site/Gifting";
import Distributors from "@/components/site/Distributors";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import AdminLeads from "@/pages/AdminLeads";

function Site() {
  useLenisScroll();
  return (
    <>
      <SEO />
      <Loader />
      <Nav />
      <main>
        <Hero />
        <Manifesto />
        <Marquee />
        <Collection />
        <TwoPaths />
        <PrivateLabel />
        <WhyUs />
        <Process />
        <Counters />
        <Gallery />
        <Gifting />
        <Distributors />
        <Testimonials />
        <FAQ />
        <PrivateLabelForm />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Site />} />
            <Route path="/admin" element={<AdminLeads />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#0F0F0F",
              color: "#F5F1E8",
              border: "1px solid rgba(201,169,97,0.4)",
              borderRadius: 0,
              fontFamily: "Manrope, sans-serif",
              fontSize: 13,
              letterSpacing: "0.06em",
            },
          }}
        />
      </LanguageProvider>
    </HelmetProvider>
  );
}
